import React, { createContext, useContext, useEffect, useState } from "react";
import socketIo from "socket.io-client";
import { useGlobal } from "./GlobalContext";

const getSocket = (accessToken, syncCode) => {
  return socketIo(process.env.REACT_APP_BASEURL_SOCKET, {
    transports: ["websocket"],
    withCredentials: true,
    auth: { token: accessToken, code: syncCode },
  });
}

const SocketContext = createContext(null);

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const { company } = useGlobal();

  useEffect(() => {
    const accessToken = JSON.parse(localStorage.getItem('authTokenCustomer'))?.access_token;
    if (!accessToken || !company?.setting?.syncCode) return;

    const socket = getSocket(accessToken, company?.setting?.syncCode);

    socket.on("connect", () => {
      console.log("Socket connected:", socket.id);
    });

    socket.on("disconnect", () => {
      console.log("Socket disconnected");
    });

    socket.on("error", (err) => {
      console.error("Socket error:", err);
    });

    setSocket(socket);

    return () => {
      socket.disconnect();
    };
  }, [company?.setting?.syncCode]);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};